import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "kt_header",
  style: {},
  class: "header align-items-stretch bg-light"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "media/logos/logo_aragon.png",
  class: "logo-aragon"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","text-align":"right","white-space":"nowrap"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/logos/logo_iam.png",
    class: "logo-iam"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/logos/logo_corresponsables.png",
    class: "logo-corresponsables"
  })
], -1)
const _hoisted_4 = { class: "d-flex align-items-stretch justify-content-end flex-lg-grow-1" }
const _hoisted_5 = { class: "d-flex align-items-stretch flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTTopbar = _resolveComponent("KTTopbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{
        'container-fluid': _ctx.headerWidthFluid,
        'container-xxl': !_ctx.headerWidthFluid,
      }, "d-flex align-items-stretch justify-content-between"])
    }, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_KTTopbar)
        ])
      ])
    ], 2)
  ]))
}